// @ts-nocheck

import { type StateType } from '../../../states';
import { type BasketState } from '../../../states/basket';
import { type GenericAction } from '../../../types/redux';

import basketAddBetbuilderItem from './basketAddBetbuilderItem';
import basketDelItem from './basketDelItem';

const basketMyMatchMerge = (state: BasketState, action: GenericAction, globalState: StateType) => {
  const { payload } = action;
  const { itemIdsToRemove, matchId, selectionItems, value } = payload ?? {};

  let stateAfterItemsDeleted = state;

  let nextTS = null;

  for (const itemId of itemIdsToRemove ?? []) {
    const currentItem = stateAfterItemsDeleted.items[itemId];

    if (currentItem) {
      const { sortBy: currentItemSortBy, matchId: currentItemMatchId } = currentItem;

      if (matchId === currentItemMatchId) {
        nextTS = currentItemSortBy;
      }

      stateAfterItemsDeleted = basketDelItem(
        stateAfterItemsDeleted,
        { payload: { oddId: itemId, keepStake: true } },
        globalState,
      );
    }
  }

  const basketItemsAsArray = Object.keys(stateAfterItemsDeleted.items).map((k) => stateAfterItemsDeleted.items[k]);
  const sameMatchIdMyMatchItems = basketItemsAsArray.filter((k) => k.betbuilder && k.matchId === matchId);

  if (sameMatchIdMyMatchItems.length) {
    return state;
  }

  // eslint-disable-next-line sonarjs/prefer-immediate-return
  const nextState = basketAddBetbuilderItem(
    stateAfterItemsDeleted,
    {
      payload: {
        matchId,
        selectionItems: selectionItems,
        value,
        source: undefined,
        ts: nextTS ?? Date.now(),
      },
    },
    globalState,
  );

  return nextState;
};

export default basketMyMatchMerge;
